skrilla.controller('betEventAuditDetailsCtrl', function ($scope, searchService, $stateParams, validationService, modalService, cacheService, srefService, sportEventService, racingEventService, adminV2Service) {

    $scope.audit = cacheService.getObjectOrElse("betEventAudit", modalService.dismissAll)
    $scope.bet = cacheService.getObjectOrElse("bet", modalService.dismissAll)
    $scope.available = {title: "Available (User)", field: $scope.audit.available};
    $scope.revenue = {title: "Revenue (System)", field: $scope.audit.revenue};
    if($scope.bet.stakeSource === "PROMOTION_USER"){
        $scope.available.title = "Promotion (User)";
        $scope.available.field = $scope.audit.promotionUser;
        $scope.revenue.title = "Promotion (System)"
        $scope.revenue.field = $scope.audit.promotionSystem;
    }

    $scope.views = [];

    $scope.audit.selections.forEach((selection) => {
        const view = $scope.bet.selections.find(s => selection.selectionId === s.id)
        view.outcomes.forEach((selectionOutcome, index) => {
            let newView = {...selection}
            const outcome = selectionOutcome.outcome
            const market = selectionOutcome.market
            newView.name = outcome.name;
            newView.marketName = market.name;
            newView.outcomeSource = outcome.sourceId.source;

            if (racingEventService.isRacingEvent(view.event.eventType)) {
                newView.eventName = view.event.attributes.venueName + ' (R' + view.event.attributes.raceNumber + ')';
                newView.eventNameOnClick = () => adminV2Service.openV2("/races/" + view.event.eventId)
            } else {
                newView.eventName = `${view.event.sport} ${view.event.eventType} ${view.event.eventName}`
                newView.eventNameOnClick = () => sportEventService.eventUrl(view.event)
            }
            newView.market = market;
            if(index === 0) {
                newView.event = view.event;
                newView.stakeDividedBySelectionsStr = getPayoutAndDeltaString(selection.stakeDividedBySelections, selection.stakeDividedBySelectionsDelta)
                newView.oddsProportionalStakeStr = getPayoutAndDeltaString(selection.oddsProportionalStake, selection.oddsProportionalStakeDelta)

                newView.vicPfiaProportionalPayoutStr = getPayoutAndDeltaString(selection.vicPfiaProportionalPayout, selection.vicPfiaProportionalPayoutDelta)
                newView.payoutDividedBySelectionsStr = getPayoutAndDeltaString(selection.payoutDividedBySelections, selection.payoutDividedBySelectionsDelta)
                newView.oddsProportionalPayoutStr = getPayoutAndDeltaString(selection.oddsProportionalPayout, selection.oddsProportionalPayoutDelta)
            }
            else{
                newView.odds = '';
                newView.oddsProportion = '';
                newView.void = '';
                newView.iteration = '';
            }
            $scope.views.push(newView);
        })
    })

    function getPayoutAndDeltaString(payout, delta){
        let deltaString = delta !== 0 ? ` ($${new BigNumber(delta).dividedBy(100).toNumber().toFixed(2)})` : ``;
        return `$${new BigNumber(payout).dividedBy(100).toNumber().toFixed(2)}${deltaString}`
    }

    $scope.showOldStatus = function(){
        return !($scope.bet.eventType === "BET_CREATED" || $scope.bet.eventType === "BET_CREATED_WITH_REJECTION");
    }

    $scope.tableData = {
        columns: [
            {title: "Iteration", field: "iteration"},
            {title: "Name", field: "name"},
            {title: "Market", field: "marketName", onClick: clickMarket, isLink: true},
            {title: "Outcome Source", field: "outcomeSource"},
            {title: "Event Name", field: "eventName", onClick: clickEventName, isLink: true},
            {title: "Most recent", field: "mostRecent"},
            {title: "Odds", field: "odds"},
            {title: "Odds proportion", field: "oddsProportion"},
            {title: "Odds proportional Stake", field: "oddsProportionalStakeStr"},
            {title: "Stake / Selections", field: "stakeDividedBySelectionsStr"},
            {title: "Payout / Selections", field: "payoutDividedBySelectionsStr"},
            {title: "Odds proportional Payout", field: "oddsProportionalPayoutStr"},
            {title: "Vic PFIA Payout", field: "vicPfiaProportionalPayoutStr"},
            {title: "Void", field: "void"},
            {title: "Created At", field: "createdAt", filter:{name: 'dateTimeFormatter'}},
        ],
        rows: {},
        isSkrillaTable: true,
        data: $scope.views
    }

    function clickMarket(selection, field, event){
        modalService.dismissAll()
        srefService.go("bettingMarketDetails", {id: selection.market.id}, event)
    }

    function clickEventName(selection, field, event){
        modalService.dismissAll()
        selection.eventNameOnClick()
    }

});
